import * as angular from 'angular';
import { ConstantItems } from '@constants/shared';
import { EmailDetails } from '@models/bulkemailing/emailDetails';

export class EmailRepo {

  /** @ngInject */
  constructor(private $http: angular.IHttpService, private config: ConstantItems) { }

  getGroupEmails() {
    return this.$http.get(`${this.config.emailUrl}/groups/emails`)
      .then(resp => resp.data as EmailDetails[])
  }

  sendGroupEmail(groupEmailRequest: FormData) {
    return this.$http.post(`${this.config.emailUrl}/groups/emails`,
      groupEmailRequest,
      {
        headers: {
          'Content-Type': undefined
        },
        transformRequest: angular.identity
      })
  }

  downloadAttachment(attachmentId) {
    return this.$http.get(`${this.config.emailUrl}/groups/emails/attachment/${attachmentId}`);
  }

  retryGroupEmail(emailId: number, recipientIds?: number[]) {
    return this.$http.post(`${this.config.emailUrl}/groups/emails/${emailId}/retry`, {
      RecipientIds: recipientIds || []
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/email.repo.ts